var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formula-capture-wrapper"},[_c('el-input',{staticClass:"shadow-sm formula-result-input",attrs:{"value":_vm.displayValue,"disabled":"","type":"text"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"formula-badge"},[_c('i',{staticClass:"fa fa-calculator"}),_vm._v(" Auto\n  ")])
}]

export { render, staticRenderFns }